/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CreditUsageSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreditUsageRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type CreditUsageSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreditUsageSecurity$outboundSchema: z.ZodMiniType<
  CreditUsageSecurity$Outbound,
  CreditUsageSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function creditUsageSecurityToJSON(
  creditUsageSecurity: CreditUsageSecurity,
): string {
  return JSON.stringify(
    CreditUsageSecurity$outboundSchema.parse(creditUsageSecurity),
  );
}

/** @internal */
export type CreditUsageRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const CreditUsageRequest$outboundSchema: z.ZodMiniType<
  CreditUsageRequest$Outbound,
  CreditUsageRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function creditUsageRequestToJSON(
  creditUsageRequest: CreditUsageRequest,
): string {
  return JSON.stringify(
    CreditUsageRequest$outboundSchema.parse(creditUsageRequest),
  );
}
